import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, LandingConfiguration } from '@domains';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class LandingConfigurationService extends BaseApiService<LandingConfiguration> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'landing_configurations', LandingConfiguration, 'LandingConfiguration');
  }
}
